<template>
    <div>
      <div style="background-image:url('/collezioni/placeholder.png')" class="collections-hero sections-hero">
        <h2 class="text-center">{{ resolve(this.$route.params.gamma) }}</h2>
      </div>
      <div class="container">
  
        <div class="breadcrumb py-3">
          <a href="https://elbi.lithos.it"> {{ 'Home' }} </a>
          <span> {{ ' / ' }} </span>
          <div style="text-decoration:underline" @click="goToPage('gamme-accessori/')"> {{ 'Accessori' }} </div>
          <span> {{ ' / ' }} </span>
          <p> {{ resolve(this.$route.params.gamma) }} </p>
        </div>
  
        <div class="pt-5 text-center">
          <p > </p>
        </div>
        <div>
          <div v-for="a in accessori" :key="a.id">
            <div class="product-container">
              <div
                v-for="prod in a.relSync('prodotti_accessori')"
                :key="prod.id"
                class="product-box"
              >
                <div class="prod-event">
                  <!-- :href="/prodotto/ + $router.resolve({ name: 'prodotto', params: { col: a.val('nome'), prodotto: prod.val('nome') } }).href + '/?lang=' +schema.lang"  -->
                  <div
                  @click="goToPage($router.resolve({ name: 'prodotto', params: { col: a.val('nome'), prodotto: prod.val('nome') } }).href + '/?lang=' +schema.lang)"
                    style="text-decoration: none; color: #000;"
                    class="prod-href"
                  >
                    <div class="square">
                      <div class="square-content">
                          <img v-if="prod.val('image')" class="img-fluid" :src="prod.val('image').link({'x':400,'y':400,'ext':'jpg'})" alt="">
                          <img v-else class="img-fluid" src="/collezioni/placeholder.png" alt="">
                      </div>
                    </div>
                    <div class="prod-name">{{ prod.val("nome") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script lang="js">
  import { defineComponent } from "@vue/runtime-core";
  import { Schema, Thing } from "onpage-js";
  
  export default defineComponent({
    props: {
      schema: {
        type: Schema,
        required: true,
      },
    },
    mounted() {
      window.document.getElementById('app').scrollIntoView()
    },
    data() {
      return {
        accessori: null,
        cerca: "",
        prodotti: {
                things: Thing
            },
      };
    },
  
    async created() {
      this.refreshAccessori();
    },
    computed: {
      accessori_query(){
        const schema = this.schema;
        if (!schema) return;
        const q = schema.query("accessori").where('nome', this.resolve(this.$route.params.gamma)).with("prodotti_accessori");
        return q;
      },
    },
    methods: {
      goToPage(path) {
        console.log(path)
        this.$router.push({ path: `/${path.replace('#/', '')}` })
      },
      async refreshAccessori() {
        this.accessori = await this.accessori_query?.all();
      },
      resolve(param){
        return param.replaceAll("-","/").replaceAll("_"," "); 
      }
    },

  });
  </script>
  
  <style>
  .sections-hero{
    background-size: cover;
  }
  .sections-hero h2{
    font-size: 112px;
    line-height: 50px;
    font-weight: 200;
  }
  .sections-hero h2 span{
    font-size: 32px;
    text-transform: none;
  }
  .sezione-name{
    padding: 1em;
    text-align: center;
    font-size: 2em;
  }
  .product-container {
    display: flex;
    flex-wrap: wrap;
  }
  .product-box {
    width: calc(100% / 4);
    padding: 10px;
    transition: all .3s;
    cursor:pointer;
  }
  .product-box:hover{
    transform: scale(1.04);
  }
  .square {
    position: relative;
    width: 100%;
  }
  .square:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
  .square-content {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .prod-name {
    padding: 1em 0;
    text-align: center;
    text-transform: uppercase;
  }
  .accessorio a{
    text-decoration: none;
    color: #000;
    font-size: 14px !important;
  }
  
  @media (max-width: 992px){
    .product-box{
      width: calc(100%/3);
    }
    .swiper-slide{
      height: auto;
      padding-right: 0;
      display: flex;
      justify-content: center;
    }
    .content-slide{
      position: relative;
      top: 0;
      right: 0;
    }
  }
  @media (max-width: 768px){
    .product-box{
      width: calc(100%/2);
    }
  }
  @media (max-width: 440px){
    .product-box{
      width: 100%;
    }
  }
  </style>
  